import React from 'react';
import './Dashboard.css';
import EcgCard from '../components/EcgCard';
import HeartRateCard from '../components/HeartRateCard';
import WebcamCard from '../components/WebcamCard';
import ActionCard from '../components/ActionCard';

const Dashboard: React.FC = () => {
  return (
    <div className="dashboard-container">
      <div className="metrics-grid">
        <HeartRateCard />
        <EcgCard />
        <WebcamCard />
        <ActionCard />
      </div>
    </div>
  );
};

export default Dashboard;
